import { Region } from '../../../../../../api/theHive/redeProto/types';
import { Constants, REGIONS } from '../../../../../../constants/redeProto';
import { PoleDetail } from '../../components/PoleDetail';
import { SectionCard } from '../../components/SectionCard';
import { StateFeedback } from '../../components/StateFeedback';
import { Note } from '../../styles';
import { MapCanvas } from './components/MapCanvas';
import { PoleList } from './components/PoleList';
import { MAP_METRICS } from './mapMetrics';
import {
  Count,
  Layout,
  MetricButton,
  MetricGroup,
  Select,
  SideColumn,
  Toolbar,
} from './styles';
import useNetworkMap from './useNetworkMap';

export function NetworkMap(): JSX.Element {
  const {
    filteredPoles,
    ufOptions,
    metric,
    setMetric,
    region,
    setRegion,
    uf,
    setUf,
    selectedPole,
    setSelectedPole,
    loading,
    error,
  } = useNetworkMap();

  return (
    <StateFeedback loading={loading} error={error} empty={false}>
      <Toolbar>
        <MetricGroup>
          {MAP_METRICS.map((item) => (
            <MetricButton
              key={item.key}
              type="button"
              active={metric === item.key}
              onClick={() => setMetric(item.key)}
            >
              {item.label}
            </MetricButton>
          ))}
        </MetricGroup>

        <Select
          value={region}
          onChange={(event) => {
            setRegion(event.target.value as Region | 'all');
            setUf('all');
          }}
        >
          <option value="all">{Constants.geoFilters.allRegions}</option>
          {REGIONS.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>

        <Select value={uf} onChange={(event) => setUf(event.target.value)}>
          <option value="all">{Constants.geoFilters.allUfs}</option>
          {ufOptions.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>

        <Count>{filteredPoles.length} polos</Count>
      </Toolbar>

      <Layout>
        <MapCanvas
          poles={filteredPoles}
          metric={metric}
          selectedPole={selectedPole}
          onSelect={setSelectedPole}
        />
        <SideColumn>
          <SectionCard title="Detalhe do polo">
            <PoleDetail pole={selectedPole} />
          </SectionCard>
          <SectionCard title={`Polos (${filteredPoles.length})`}>
            <PoleList
              poles={filteredPoles}
              metric={metric}
              selectedPole={selectedPole}
              onSelect={setSelectedPole}
            />
          </SectionCard>
        </SideColumn>
      </Layout>

      <Note>{Constants.map.approximatePosition}</Note>
    </StateFeedback>
  );
}
